import { styled, Tooltip } from '@mui/material';

const PREFIX = 'DeleteRowButton';

export const classes = {
  deleteButton: `${PREFIX}-deleteButton`,
};

export const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .${classes.deleteButton}`]: {
    opacity: 0,
    transition: 'ease opacity 0.5s',
    padding: theme.spacing(0.5),
    float: 'left',
  },
}));